import type { IConsent } from '../types';

export const consents: IConsent[] = [
  {
    id: 'hasConsent1',
    href: `/files/legal/general_terms_and_conditions_{lang}.pdf`,
    label: 'WIZARD.SUMMARY.CONSENT_ONE',
    includedForCountries: new Set(['*']),
    requiredForCountries: new Set(['*']),
  },
  {
    id: 'hasConsent2',
    href: `/files/legal/general_terms_and_conditions_{lang}.pdf`,
    label: 'WIZARD.SUMMARY.CONSENT_TWO',
    includedForCountries: new Set(['*']),
    requiredForCountries: new Set(['*']),
  },
  {
    id: 'hasConsent3',
    label: 'WIZARD.SUMMARY.CONSENT_THREE',
    includedForCountries: new Set(['*']),
    requiredForCountries: new Set(['*']),
  },
  {
    id: 'hasConsent4',
    label: 'WIZARD.SUMMARY.CONSENT_FOUR',
    includedForCountries: new Set(['*']),
    requiredForCountries: new Set(),
  },
  {
    id: 'hasConsent5',
    label: 'WIZARD.SUMMARY.CONSENT_FIVE',
    includedForCountries: new Set(['*']),
    requiredForCountries: new Set(),
  },
  {
    id: 'hasConsent6',
    label: 'WIZARD.SUMMARY.CONSENT_SIX',
    includedForCountries: new Set(['FR']),
    requiredForCountries: new Set(['FR']),
  },
];
